import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import { Col, Container, Row } from "react-bootstrap";
import TopBar from "./TopBar";
import { useNavigate } from "react-router-dom";

const GetEmployee = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/listemployees");
  }
  const { employeeId } = useParams(); // Get the employeeId from the URL
  const [employee, setEmployee] = useState(null);  // To store fetched employee data
  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null);    // To handle errors
  const axiosPrivate = useAxiosPrivate();

  // Construct URL dynamically based on the employeeId
  const GET_EMPLOYEE_URL = `api/get-employee?employee_id=${employeeId}`;

  useEffect(() => {
    const fetchData = async () => {
      const headers = {
        'Content-Type': 'application/json',
      };

      try {
        const response = await axiosPrivate.get(GET_EMPLOYEE_URL, {
          headers,
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });
        setEmployee(response.data); // Store the fetched data into the employee state
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
        setLoading(false);  // Set loading to false even if there is an error
      }
    };

    fetchData();
  }, [employeeId]);  // Add employeeId as a dependency to re-fetch data if employeeId changes

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner component if you prefer
  }

  if (error) {
    return <div>{error}</div>; // Display error message if any
  }

  if (employee) {
    return (
      <>
        {/* <Container> */}
        <section className="empbody">
          <div className="wrapperemp">
            <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">Employee List</button>
            <h3>Employee Details</h3>
            <Row>
              <Col>
                <p><span className="empspan">Employee Id :</span> {employee.employee_id}</p>
              </Col>
              <Col>
                <p><span className="empspan">Employee Code :</span> {employee.employee_code}</p>
              </Col>
            </Row>
            <Row>
              <Col>

                <p><span className="empspan">Name :</span> {employee.name}</p>
              </Col>
              <Col>

                <p><span className="empspan">Id Card Number :</span> {employee.id_card_number}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p><span className="empspan">Id Card Type :</span> {employee.id_card_type}</p>
              </Col>
              <Col>
                <p><span className="empspan">Designation :</span> {employee.designation}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p><span className="empspan">Date Of Join :</span> {employee.date_of_join}</p>
              </Col>
              <Col>
                <p><span className="empspan">Address :</span> {employee.address}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p><span className="empspan">City :</span> {employee.city}</p>
              </Col>
              <Col>
                <p><span className="empspan">Pincode :</span> {employee.pincode}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p><span className="empspan">State :</span> {employee.state}</p>
              </Col>
              <Col>
                <p><span className="empspan">Mobile1 :</span> {employee.mobile1}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p><span className="empspan">Mobile2 :</span> {employee.mobile2}</p>
              </Col>
              <Col>
                <p><span className="empspan">Email :</span> {employee.email}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p><span className="empspan">Status :</span> {employee.status}</p>
              </Col>
              <Col>
                <p><span className="empspan">Franchise Id :</span> {employee.franchise_id}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <p><span className="empspan">Franchise Code :</span> {employee.franchise_code}</p>
              </Col>
              <Col>
                <p><span className="empspan">Franchise Name :</span> {employee.franchise_name}</p>
              </Col>
            </Row>

          </div>
        </section>
        <TopBar />
        {/* </Container> */}
      </>
    );
  }

  return <div>No Employee data available.</div>;
};

export default GetEmployee;
